export default __webpack_public_path__ + "static/media/Bionic-Arm-02.d8b636ce.jpg";